/* V154 — Variant B copy (loss-aversion / specific numbers) + 6 EU langs.
   Headlines focus on concrete EUR amounts so e-shop owners see real loss/cost. */

export const AD_TRANSLATIONS = {
  sk: {
    page_title: "🎬 Reklama · AI Agenti pre e-shop",
    page_sub: "44-sekundový animovaný spot. Klikni '🎥 NAHRAŤ MP4' alebo nahraj cez Loom / OBS. Pre IG Reels, TikTok, FB Feed, YouTube Shorts.",
    rec_btn: "🎥 NAHRAŤ MP4 (44s)",
    rec_btn_active: "● NAHRÁVAM…",
    rec_btn_stop: "■ ZASTAVIŤ",
    rec_hint: "Po kliknutí vyber tento tab → automaticky sa nahrá 44s loop → stiahne sa .webm súbor (Meta, TikTok, YouTube ho akceptujú priamo)",
    rec_err: "Chyba pri nahrávaní:",
    rec_progress: "Nahrávam",
    aspect_9_16: "📱 9:16 Reels/TikTok",
    aspect_1_1: "🔲 1:1 FB Feed",
    aspect_16_9: "📺 16:9 YouTube",
    hide_tip: "✕ Skry tip", show_tip: "💡 Ukáž tip",
    help_title: "Ako nahrať video:",
    help_mac: "Mac:", help_mac_steps: '→ "Record selected portion" → vyber spot → Record (44s) → Stop',
    help_win: "Windows:", help_win_steps: "Game Bar alebo OBS Studio (free)",
    help_online: "Online:", help_online_steps: "Loom.com (zadarmo, exportuje MP4)",
    help_stop: "Stop po", help_one_loop: "1 plnom loope (~44s)",
    help_or_longer: "alebo nech beží 2×88s pre dlhšiu reklamu",
    help_done: "Hotový MP4 → upload na IG Ads, FB Ads, TikTok Ads Manager",
    // Variant B slides
    eyebrow_intro: "📦 OPUSTENÉ KOŠÍKY",
    slide_1: "Strácaš €3 200",
    slide_1_sub: "mesačne. Bez agenta.",
    eyebrow_pain: "📧 RUČNÝ INBOX",
    slide_2: "Míňaš €1 200",
    slide_2_sub: "mesačne. Na rovnakých odpovediach.",
    eyebrow_solution: "🎯 RIEŠENIE",
    slide_3_a: "Agent za",
    slide_3_b: "€89/mes.",
    slide_3_sub: "Vráti €4 400 mesačne navyše.",
    cta_brand: "⚡ TOPRANKPULSE",
    cta_main: "PORÁTAJ SI ÚSPORU",
    cta_url: "toprankpulse.com/prenajmi-si-agenta",
    cta_fine: "14 DNÍ ZADARMO · ŽIADNA KARTA · GDPR · EU",
    price_suffix: "/mes",
    agents: [
      {
        name: "HELPDESK",
        tagline: "Odpíše skôr než stihneš otvoriť Gmail.",
        saves: [{ num: "15h", label: "týždenne ušetrí" }, { num: "€1 200", label: "mesačne ušetrí" }],
      },
      {
        name: "CART RECOVERY",
        tagline: "Vráti opustené košíky späť. Bez kliku.",
        saves: [{ num: "+23-31%", label: "recovery rate" }, { num: "€3 200", label: "mesačne navyše" }],
      },
      {
        name: "AGENT OBCHODNÍK",
        tagline: "Nájde diery, zlaté prasiatka, funnely.",
        saves: [{ num: "8h", label: "týždenne ušetrí" }, { num: "€4 000", label: "mesačne ušetrí" }],
      },
    ],
  },
  cs: {
    page_title: "🎬 Reklama · AI Agenti pro e-shop",
    page_sub: "44-sekundový animovaný spot. Klikni '🎥 NAHRÁT MP4' nebo přes Loom / OBS. Pro IG Reels, TikTok, FB Feed, YouTube Shorts.",
    rec_btn: "🎥 NAHRÁT MP4 (44s)",
    rec_btn_active: "● NAHRÁVÁM…",
    rec_btn_stop: "■ ZASTAVIT",
    rec_hint: "Po kliknutí vyber tento tab → automaticky se nahraje 44s loop → stáhne se .webm soubor (Meta, TikTok, YouTube ho akceptují přímo)",
    rec_err: "Chyba při nahrávání:",
    rec_progress: "Nahrávám",
    aspect_9_16: "📱 9:16 Reels/TikTok", aspect_1_1: "🔲 1:1 FB Feed", aspect_16_9: "📺 16:9 YouTube",
    hide_tip: "✕ Skrýt tip", show_tip: "💡 Ukaž tip",
    help_title: "Jak nahrát video:",
    help_mac: "Mac:", help_mac_steps: '→ "Record selected portion" → vyber spot → Record (44s) → Stop',
    help_win: "Windows:", help_win_steps: "Game Bar nebo OBS Studio (free)",
    help_online: "Online:", help_online_steps: "Loom.com (zdarma, exportuje MP4)",
    help_stop: "Stop po", help_one_loop: "1 plném loopu (~44s)",
    help_or_longer: "nebo nech běží 2×88s pro delší reklamu",
    help_done: "Hotový MP4 → upload na IG Ads, FB Ads, TikTok Ads Manager",
    eyebrow_intro: "📦 OPUŠTĚNÉ KOŠÍKY",
    slide_1: "Ztrácíš €3 200", slide_1_sub: "měsíčně. Bez agenta.",
    eyebrow_pain: "📧 RUČNÍ INBOX",
    slide_2: "Utrácíš €1 200", slide_2_sub: "měsíčně. Na stejných odpovědích.",
    eyebrow_solution: "🎯 ŘEŠENÍ",
    slide_3_a: "Agent za", slide_3_b: "€89/měs.",
    slide_3_sub: "Vrátí €4 400 měsíčně navíc.",
    cta_brand: "⚡ TOPRANKPULSE", cta_main: "SPOČÍTEJ SI ÚSPORU",
    cta_url: "toprankpulse.com/pronajmi-si-agenta",
    cta_fine: "14 DNÍ ZDARMA · BEZ KARTY · GDPR · EU",
    price_suffix: "/měs",
    agents: [
      { name: "HELPDESK", tagline: "Odpoví dřív než stihneš otevřít Gmail.",
        saves: [{ num: "15h", label: "týdně ušetří" }, { num: "€1 200", label: "měsíčně ušetří" }] },
      { name: "CART RECOVERY", tagline: "Vrátí opuštěné košíky zpět. Bez kliku.",
        saves: [{ num: "+23-31%", label: "recovery rate" }, { num: "€3 200", label: "měsíčně navíc" }] },
      { name: "AGENT OBCHODNÍK", tagline: "Najde díry, zlatá prasátka, funnely.",
        saves: [{ num: "8h", label: "týdně ušetří" }, { num: "€4 000", label: "měsíčně ušetří" }] },
    ],
  },
  en: {
    page_title: "🎬 Ad · AI Agents for E-shop",
    page_sub: "44-second animated spot. Click '🎥 RECORD MP4' or use Loom / OBS. For IG Reels, TikTok, FB Feed, YouTube Shorts.",
    rec_btn: "🎥 RECORD MP4 (44s)", rec_btn_active: "● RECORDING…", rec_btn_stop: "■ STOP",
    rec_hint: "After clicking, select this tab → 44s loop auto-records → .webm file downloads (Meta, TikTok, YouTube accept it directly)",
    rec_err: "Recording error:", rec_progress: "Recording",
    aspect_9_16: "📱 9:16 Reels/TikTok", aspect_1_1: "🔲 1:1 FB Feed", aspect_16_9: "📺 16:9 YouTube",
    hide_tip: "✕ Hide tip", show_tip: "💡 Show tip",
    help_title: "How to record:",
    help_mac: "Mac:", help_mac_steps: '→ "Record selected portion" → select spot → Record (44s) → Stop',
    help_win: "Windows:", help_win_steps: "Game Bar or OBS Studio (free)",
    help_online: "Online:", help_online_steps: "Loom.com (free, exports MP4)",
    help_stop: "Stop after", help_one_loop: "1 full loop (~44s)",
    help_or_longer: "or let it run 2×88s for a longer ad",
    help_done: "Final MP4 → upload to IG Ads, FB Ads, TikTok Ads Manager",
    eyebrow_intro: "📦 ABANDONED CARTS",
    slide_1: "Losing €3,200", slide_1_sub: "per month. Without an agent.",
    eyebrow_pain: "📧 MANUAL INBOX",
    slide_2: "Spending €1,200", slide_2_sub: "per month. On the same replies.",
    eyebrow_solution: "🎯 THE FIX",
    slide_3_a: "Agent for", slide_3_b: "€89/mo.",
    slide_3_sub: "Returns €4,400 extra each month.",
    cta_brand: "⚡ TOPRANKPULSE", cta_main: "CALCULATE YOUR SAVINGS",
    cta_url: "toprankpulse.com/rent-an-agent",
    cta_fine: "14 DAYS FREE · NO CARD · GDPR · EU",
    price_suffix: "/mo",
    agents: [
      { name: "HELPDESK", tagline: "Replies before you open Gmail.",
        saves: [{ num: "15h", label: "saved weekly" }, { num: "€1,200", label: "saved monthly" }] },
      { name: "CART RECOVERY", tagline: "Wins back abandoned carts. No clicks needed.",
        saves: [{ num: "+23-31%", label: "recovery rate" }, { num: "€3,200", label: "extra monthly" }] },
      { name: "SALES HUNTER", tagline: "Finds gaps, gold mines, funnels.",
        saves: [{ num: "8h", label: "saved weekly" }, { num: "€4,000", label: "saved monthly" }] },
    ],
  },
  de: {
    page_title: "🎬 Anzeige · AI-Agenten für E-Shop",
    page_sub: "44-Sekunden Spot. Klick '🎥 MP4 AUFNEHMEN' oder Loom / OBS. Für IG Reels, TikTok, FB Feed, YouTube Shorts.",
    rec_btn: "🎥 MP4 AUFNEHMEN (44s)", rec_btn_active: "● AUFNAHME…", rec_btn_stop: "■ STOPP",
    rec_hint: "Nach Klick diesen Tab wählen → 44s Loop nimmt automatisch auf → .webm Datei wird heruntergeladen",
    rec_err: "Aufnahmefehler:", rec_progress: "Aufnahme",
    aspect_9_16: "📱 9:16 Reels/TikTok", aspect_1_1: "🔲 1:1 FB Feed", aspect_16_9: "📺 16:9 YouTube",
    hide_tip: "✕ Tipp ausblenden", show_tip: "💡 Tipp anzeigen",
    help_title: "Wie aufnehmen:",
    help_mac: "Mac:", help_mac_steps: '→ "Record selected portion" → Bereich wählen → Record (44s) → Stop',
    help_win: "Windows:", help_win_steps: "Game Bar oder OBS Studio (kostenlos)",
    help_online: "Online:", help_online_steps: "Loom.com (kostenlos, MP4 Export)",
    help_stop: "Stop nach", help_one_loop: "1 vollem Loop (~44s)",
    help_or_longer: "oder 2×88s für längere Werbung",
    help_done: "Fertiges MP4 → Upload zu IG Ads, FB Ads, TikTok Ads Manager",
    eyebrow_intro: "📦 VERLASSENE WARENKÖRBE",
    slide_1: "Verlierst €3.200", slide_1_sub: "pro Monat. Ohne Agent.",
    eyebrow_pain: "📧 MANUELLER INBOX",
    slide_2: "Verschwendest €1.200", slide_2_sub: "pro Monat. Für die gleichen Antworten.",
    eyebrow_solution: "🎯 DIE LÖSUNG",
    slide_3_a: "Agent ab", slide_3_b: "€89/Mon.",
    slide_3_sub: "Bringt €4.400 extra pro Monat zurück.",
    cta_brand: "⚡ TOPRANKPULSE", cta_main: "ERSPARNIS BERECHNEN",
    cta_url: "toprankpulse.com/agenten-mieten",
    cta_fine: "14 TAGE GRATIS · KEINE KARTE · DSGVO · EU",
    price_suffix: "/Mon",
    agents: [
      { name: "HELPDESK", tagline: "Antwortet bevor du Gmail öffnest.",
        saves: [{ num: "15h", label: "pro Woche gespart" }, { num: "€1.200", label: "pro Monat gespart" }] },
      { name: "CART RECOVERY", tagline: "Holt verlassene Warenkörbe zurück. Ohne Klick.",
        saves: [{ num: "+23-31%", label: "Recovery Rate" }, { num: "€3.200", label: "extra pro Monat" }] },
      { name: "SALES HUNTER", tagline: "Findet Lücken, Goldgruben, Funnels.",
        saves: [{ num: "8h", label: "pro Woche gespart" }, { num: "€4.000", label: "pro Monat gespart" }] },
    ],
  },
  pl: {
    page_title: "🎬 Reklama · Agenci AI dla e-sklepu",
    page_sub: "44-sekundowy spot. Kliknij '🎥 NAGRAJ MP4' lub przez Loom / OBS. Dla IG Reels, TikTok, FB Feed, YouTube Shorts.",
    rec_btn: "🎥 NAGRAJ MP4 (44s)", rec_btn_active: "● NAGRYWAM…", rec_btn_stop: "■ STOP",
    rec_hint: "Po kliknięciu wybierz ten tab → automatycznie nagra 44s loop → pobierze plik .webm",
    rec_err: "Błąd nagrywania:", rec_progress: "Nagrywam",
    aspect_9_16: "📱 9:16 Reels/TikTok", aspect_1_1: "🔲 1:1 FB Feed", aspect_16_9: "📺 16:9 YouTube",
    hide_tip: "✕ Ukryj tip", show_tip: "💡 Pokaż tip",
    help_title: "Jak nagrać video:",
    help_mac: "Mac:", help_mac_steps: '→ "Record selected portion" → wybierz spot → Record (44s) → Stop',
    help_win: "Windows:", help_win_steps: "Game Bar lub OBS Studio (darmowe)",
    help_online: "Online:", help_online_steps: "Loom.com (darmowe, exportuje MP4)",
    help_stop: "Stop po", help_one_loop: "1 pełnym loopie (~44s)",
    help_or_longer: "lub niech leci 2×88s dla dłuższej reklamy",
    help_done: "Gotowy MP4 → upload na IG Ads, FB Ads, TikTok Ads Manager",
    eyebrow_intro: "📦 PORZUCONE KOSZYKI",
    slide_1: "Tracisz €3 200", slide_1_sub: "miesięcznie. Bez agenta.",
    eyebrow_pain: "📧 RĘCZNY INBOX",
    slide_2: "Wydajesz €1 200", slide_2_sub: "miesięcznie. Na tych samych odpowiedziach.",
    eyebrow_solution: "🎯 ROZWIĄZANIE",
    slide_3_a: "Agent za", slide_3_b: "€89/mies.",
    slide_3_sub: "Zwraca €4 400 miesięcznie extra.",
    cta_brand: "⚡ TOPRANKPULSE", cta_main: "POLICZ OSZCZĘDNOŚĆ",
    cta_url: "toprankpulse.com/wynajmij-agenta",
    cta_fine: "14 DNI GRATIS · BEZ KARTY · RODO · UE",
    price_suffix: "/mies",
    agents: [
      { name: "HELPDESK", tagline: "Odpisze zanim otworzysz Gmail.",
        saves: [{ num: "15h", label: "tygodniowo oszczędza" }, { num: "€1 200", label: "miesięcznie oszczędza" }] },
      { name: "CART RECOVERY", tagline: "Odzyskuje porzucone koszyki. Bez klika.",
        saves: [{ num: "+23-31%", label: "recovery rate" }, { num: "€3 200", label: "miesięcznie extra" }] },
      { name: "SALES HUNTER", tagline: "Znajduje luki, złote żyły, funnele.",
        saves: [{ num: "8h", label: "tygodniowo oszczędza" }, { num: "€4 000", label: "miesięcznie oszczędza" }] },
    ],
  },
  hu: {
    page_title: "🎬 Reklám · AI Ügynökök e-shopnak",
    page_sub: "44 másodperces spot. Kattints '🎥 MP4 RÖGZÍTÉS' vagy Loom / OBS. IG Reels, TikTok, FB Feed, YouTube Shorts számára.",
    rec_btn: "🎥 MP4 RÖGZÍTÉS (44s)", rec_btn_active: "● RÖGZÍTÉS…", rec_btn_stop: "■ MEGÁLLÍT",
    rec_hint: "Kattintás után válaszd ezt a tabot → automatikusan rögzít 44s loopot → .webm fájl letöltődik",
    rec_err: "Rögzítési hiba:", rec_progress: "Rögzítés",
    aspect_9_16: "📱 9:16 Reels/TikTok", aspect_1_1: "🔲 1:1 FB Feed", aspect_16_9: "📺 16:9 YouTube",
    hide_tip: "✕ Tipp elrejt", show_tip: "💡 Tipp mutat",
    help_title: "Hogyan rögzítsd:",
    help_mac: "Mac:", help_mac_steps: '→ "Record selected portion" → válaszd a spotot → Record (44s) → Stop',
    help_win: "Windows:", help_win_steps: "Game Bar vagy OBS Studio (ingyenes)",
    help_online: "Online:", help_online_steps: "Loom.com (ingyenes, MP4 export)",
    help_stop: "Stop", help_one_loop: "1 teljes loop után (~44s)",
    help_or_longer: "vagy hagyd futni 2×88s a hosszabb reklámért",
    help_done: "Kész MP4 → tölts fel IG Ads, FB Ads, TikTok Ads Manager-be",
    eyebrow_intro: "📦 ELHAGYOTT KOSARAK",
    slide_1: "€3 200 elveszik", slide_1_sub: "havonta. Ügynök nélkül.",
    eyebrow_pain: "📧 KÉZI INBOX",
    slide_2: "€1 200-t költesz", slide_2_sub: "havonta. Ugyanazokra a válaszokra.",
    eyebrow_solution: "🎯 A MEGOLDÁS",
    slide_3_a: "Ügynök", slide_3_b: "€89/hó.",
    slide_3_sub: "€4 400 extra bevétel havonta.",
    cta_brand: "⚡ TOPRANKPULSE", cta_main: "SZÁMOLD KI A MEGTAKARÍTÁST",
    cta_url: "toprankpulse.com/berelj-ugynokot",
    cta_fine: "14 NAP INGYEN · KÁRTYA NÉLKÜL · GDPR · EU",
    price_suffix: "/hó",
    agents: [
      { name: "HELPDESK", tagline: "Válaszol mielőtt megnyitnád a Gmail-t.",
        saves: [{ num: "15h", label: "hetente megspórol" }, { num: "€1 200", label: "havonta megspórol" }] },
      { name: "CART RECOVERY", tagline: "Visszahozza az elhagyott kosarakat. Kattintás nélkül.",
        saves: [{ num: "+23-31%", label: "recovery rate" }, { num: "€3 200", label: "havonta extra" }] },
      { name: "SALES HUNTER", tagline: "Megtalálja a réseket, aranybányákat, funneleket.",
        saves: [{ num: "8h", label: "hetente megspórol" }, { num: "€4 000", label: "havonta megspórol" }] },
    ],
  },
};

export const AD_LANGUAGES = [
  { code: "sk", flag: "🇸🇰", name: "Slovenčina" },
  { code: "cs", flag: "🇨🇿", name: "Čeština" },
  { code: "en", flag: "🇬🇧", name: "English" },
  { code: "de", flag: "🇩🇪", name: "Deutsch" },
  { code: "pl", flag: "🇵🇱", name: "Polski" },
  { code: "hu", flag: "🇭🇺", name: "Magyar" },
];

export function getAdLang() {
  if (typeof window === "undefined") return "sk";
  const sp = new URLSearchParams(window.location.search);
  const fromUrl = (sp.get("lang") || "").toLowerCase().slice(0, 2);
  if (AD_TRANSLATIONS[fromUrl]) return fromUrl;
  const nav = (navigator.language || "sk").toLowerCase().slice(0, 2);
  if (AD_TRANSLATIONS[nav]) return nav;
  return "sk";
}
